import { flow, pickBy } from '../../../lib/utilities';
import { executeIfFunction } from './execute_if_function';

export const fillStringArrayConditionally = (conditions) => (
    valueContainer = {}
) =>
    flow(
        (obj) =>
            pickBy(obj, (condition) =>
                executeIfFunction(condition, valueContainer)
            ),
        (x) => Object.keys(x)
    )(conditions);
